import React from 'react';
import BuildingScreens from '../../sections/reactNative/BuildingScreens';
import StartingWithReactNative from '../../sections/reactNative/StartingWithReactNative';

const ReactNativeHome = () => {
	return (
		<section>
			<StartingWithReactNative />
			<BuildingScreens />
		</section>
	)
};

export default ReactNativeHome;